import { render } from "./ReportView.vue?vue&type=template&id=20c21eee&ts=true"
import script from "./ReportView.vue?vue&type=script&lang=ts"
export * from "./ReportView.vue?vue&type=script&lang=ts"

import "./ReportView.vue?vue&type=style&index=0&id=20c21eee&lang=css"

import exportComponent from "/app/ViewpointPBIEmbedded/ViewpointPBIEmbedded.BFF/ClientApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__